import { render, staticRenderFns } from "./SortEditor.vue?vue&type=template&id=bed35298"
import script from "./SortEditor.vue?vue&type=script&lang=js"
export * from "./SortEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports